/* eslint-disable no-use-before-define */
import React from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'

const AutocompleteInput = ({ options, label, placeholder, value, onChange }) => (
  <Autocomplete
    value={value}
    onChange={(_, value) => onChange(value)}
    freeSolo
    options={options}
    renderInput={(params) => (
      <TextField {...params} label={label} variant="standard" onChange={e => onChange(e.target.value)} placeholder={placeholder} />
    )}
  />
);

export default AutocompleteInput
